// @flow

import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

import { SimpleFlex } from '../../components';
import Icon from '../../components/Icons';
import GenericForm from '../../components/Form';
import BaseButton, {
  LinkButton as BaseLinkButton,
} from '../../components/Button';

import ImgBg from '../../assets/appbackground.jpg';

import typeof TTheme from '../../theme';

type TP = { theme: TTheme, embedded?: boolean };

const MobileContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }: TP) => theme.colors.primary};
  box-shadow: 0 4px 0 0 ${({ theme }: TP) => theme.colors.black20};
  color: ${({ theme }: TP) => theme.colors.white};
  display: flex;
  font-size: 16px;
  height: 60px;
  padding: 0 1em;
  text-align: center;
`;

export const Form = styled(GenericForm)`
  margin-left: auto;
  margin-right: auto;
  max-width: 350px;
`;

const StyledBackIcon = styled(Icon)`
  cursor: pointer;
  transition: transform 0.1s ease-in;
  &:focus,
  &:hover {
    transform: scale(1.2);
  }
`;

const BackIcon = withRouter(props => (
  <StyledBackIcon
    type="back"
    onClick={props.onClick || props.history.goBack}
    tabIndex={-1}
  />
));

export const MobileHeader = (props: Object) => (
  <MobileContainer>
    <BackIcon onClick={props.onBackClick} />
    <SimpleFlex flex={1}>{props.children}</SimpleFlex>
  </MobileContainer>
);

export const Container = styled.div`
  background-color: #fff;
  background-image: url(${ImgBg});
  background-position: center 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
`;

export const Content = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 540px;
  padding-top: 100px;
  text-align: center;
`;

export const Title = styled.h2`
  color: ${({ theme }: TP) => theme.colors.primary};
  font-size: ${({ theme }: TP) => theme.typography.size.title};
  font-weight: normal;
  margin: 16px 0;
`;

export const P = styled.p`
  color: ${({ theme }: TP) => theme.colors.dark};
  font-size: ${({ theme }: TP) => theme.typography.size.standard};
  line-height: 1.5;
`;

export const Anchor = styled.a`
  color: ${({ theme }: TP) => theme.colors.primary};
  display: inline-block;
  text-decoration: none;
  &:focus {
    outline: 0;
  }
`;

export const Button = styled(BaseButton)`
  display: block;
  margin: 20px auto;
  width: 60%;
`;

export const LinkButton = styled(BaseLinkButton)`
  display: block;
  margin: 20px auto;
  width: 50%;
`;



// WEBPACK FOOTER //
// ./src/Auth/components/index.js